<template>
	<div style="width: 100%; height: 100%;">
		<div style="padding: 6px;font-size: 16px;"
			v-if="isNeedText(selectdItem.compontChildren[0].data.text.list) == ''">
			请添加文本
		</div>
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>
		<div style="cursor: pointer;" v-if="isNeedText(selectdItem.compontChildren[0].data.text.list) != ''">
			<div class="linktit" v-html="getHtml(selectdItem.compontChildren[0].data.text.list)"
				:style="{'--hover': compontentStyle.hoverColor}"
				@click="hrefNavTo(selectdItem.compontChildren[0].data)">
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getUrl_name
	} from '../../api/all.js'
	export default {
		props: {
			all_setting: {
				type: Array,
				default: () => {
					return []
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
			equipment: {
				type: String,
				default: "pc"
			},
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				loading:false
			}
		},
		mounted() {
			// console.log('selectdItemselectdItemselectdItemselectdItem',this.selectdItem)
		},
		methods: {
			async hrefNavTo(item) {
				
				console.log('hrefNavTo', item)
				if(this.type == 'design') {
					return
				}
				console.log('hrefNavTo',item)
				if(!item.link){
					return
				}
				if(item.link.cacheLinkIndex == '首页') {
					this.$router.push({
						path: '/'
					})
					return
				}
				if(item.link.cacheLinkIndex == '商品分类') {
					try{
						this.loading = true
						const urlData = await getUrl_name({
							type:"categories",
							id:item.link.link.id
						})
						this.$router.push({
							path: '/categories/' + urlData.data.data
						})
						this.loading = false
					}catch(e) {
						this.loading = false
					}
					return
				}
				
				
				if(item.link.cacheLinkIndex == '商品') {
					
					try{
						this.loading = true
						const urlData = await getUrl_name({
							type:"products",
							id:item.link.link.id
						})
						
						this.$router.push({
							path: '/products/' + urlData.data.data
						})
						this.loading = false
					}catch(e) {
						this.loading = false
					}
					return
				}
				
				
				
				let url = item.link.link.url
				if (item.link.link.type == '站内链接') {
				
				}
				if (item.link.link.type == "外部链接") {
					window.open(item.link.link.name);
					return
				}
				
				if (item.link.link.type == '站内链接') {
					// 判断是否是站内链接
					console.log('item.link', item.link)
					console.log(window.location.host)
					if (item.link.link.name.indexOf(window.location.host) != -1) {
						let arr = item.link.link.name.split(window.location.host)
						this.$router.push({
							path: arr[1],
						})
						return
					} else {
						window.open(item.link.link.name);
						return 
					}
				}
				if(url) {
					this.$router.push({
						path: '/' + url,
					})
				}
				
			},
			getHtml(list) {
				console.log('systemConfigsystemConfigsystemConfig', this.systemConfig)
				let text = ''
				for (let i = 0; i < list.length; i++) {
					if (this.systemConfig.locale == list[i].language) {
						if (list[i].text != '') {
							text = list[i].text
						}
					}

				}
				return text
			},
			isNeedText(e) {
				let text = ''
				e.forEach(item => {
					if (item.text != '') {
						text = item.text
					}
				})
				return text
			}
		}
	}
</script>

<style scoped lang="scss">
	.linktit:hover {
		cursor: pointer;
		color: var(--hover);
	}
</style>